import React from "react";
import { Fade } from "react-awesome-reveal";

export default function Reveal({
  children,
  className = "",
  direction = "up",
  delay = 0,
  duration = 650,
  triggerOnce = true,
  fraction = 0.12,
  cascade = false,
  damping = 0.12,
}) {
  return (
    <Fade
      direction={direction}
      delay={delay}
      duration={duration}
      triggerOnce={triggerOnce}
      fraction={fraction}
      cascade={cascade}
      damping={damping}
      className={className}
    >
      {children}
    </Fade>
  );
}